import React from "react";
import { useTranslation } from "react-i18next";
import KPIDoughnutChart from "./KPIDoughnutChart";
import styles from "../../pages/Welcome/style.module.scss";

/**
 * Metric 11: overall P/N/Neu/Mixed + inner doughnut for polarities inside mixed
 * reviews (unique sentiments per review, same as console sentiment=33).
 */
const WelcomeDualSentimentDoughnutCharts = ({ data, theme }) => {
  const { t } = useTranslation();
  const primary = data?.primary;
  const mixed = data?.mixed_breakdown;

  const primaryData = primary?.datasets?.[0]?.data;
  const mixedSlicePct =
    Array.isArray(primaryData) && primaryData.length > 3
      ? Number(primaryData[3]) || 0
      : 0;
  const mixedInnerSum = (mixed?.datasets?.[0]?.data || []).reduce(
    (acc, v) => acc + (Number(v) > 0 ? Number(v) : 0),
    0,
  );
  const showMixedColumn = mixedSlicePct > 0 && mixedInnerSum > 0;
  const primaryCustomLabels =
    primary?.legend && Array.isArray(primary.legend)
      ? primary.legend.map((item) => item.count)
      : null;
  const mixedCustomLabels =
    mixed?.legend && Array.isArray(mixed.legend)
      ? mixed.legend.map((item) => item.count)
      : null;

  return (
    <div
      className={`${styles.welcomeDualSentimentRow} ${
        !showMixedColumn ? styles.welcomeDualSentimentRowSingle : ""
      }`.trim()}
    >
      <div className={styles.welcomeDualSentimentCol}>
        <div className={styles.welcomeDualSentimentChartTitle}>
          {t("welcome.sentimentDistPrimaryTitle", "General distribution")}
        </div>
        <KPIDoughnutChart
          data={primary}
          theme={theme}
          showLegend
          customLabels={primaryCustomLabels}
        />
      </div>
      {showMixedColumn && (
        <div className={styles.welcomeDualSentimentCol}>
          <div className={styles.welcomeDualSentimentChartTitle}>
            {t("welcome.sentimentDistMixedTitle", "Mixed breakdown")}
          </div>
          <KPIDoughnutChart
            data={mixed}
            theme={theme}
            showLegend
            customLabels={mixedCustomLabels}
          />
        </div>
      )}
    </div>
  );
};

export default WelcomeDualSentimentDoughnutCharts;
